import AnimatedSpriteResponsive from "../AnimatedSpriteResponsive";
import Library                  from "../../utils/Library";
import * as PIXI               from "pixi.js";
import { gsap } from "gsap";

export default class Rain extends PIXI.Container
{
    constructor(responsive)
    {
        super();

        this.alpha = 0.5;
        this.arrSp = [];

        this.responsive = responsive;

        this.buildAnimation();
    }

    buildAnimation ()
    {
        let objAnim = {anim: "pluie", atlas: `pluie`, key: `ME_rain`,};


        let sheet = Library.instance.getTexture(objAnim.atlas);

        for (let i = 0; i < 9; i++)
        {

            let sprite = PIXI.AnimatedSprite.fromFrames(sheet.data.animations[objAnim.key]);

            if (this.responsive.anchor)
                sprite.anchor = this.responsive.anchor;


            sprite.animationSpeed = (4 + Math.random() * 3) / 60
            sprite.alpha = 0.2;


            this.arrSp.push(sprite);
            this.addChild(sprite);
        }


    }


    start (animation)
    {
        for (let i = 0; i < this.arrSp.length; i++)
        {
            let sprite = this.arrSp[i];
            sprite.play();

        }
    }

    startAnimationMovement ()
    {

    }
    setResponsive (responsive)
    {
        this.responsive = responsive;

        if (this.responsive.anchor)
            this.anchor = this.responsive.anchor;
    }


    layout (width, height)
    {

        let xOffset = width / 1.5;
        let yOffset = height /2;

        this.x = parseFloat(this.responsive.params.x.gravity) * width;
        this.y = 0;


        let pos = [ [ -0.1 ,-0.1], [0.25,-0.1], [0.6, -0.1],
                         [ -0.1 , 0.3],  [0.25,0.3],  [0.6, 0.3],
                        [ -0.1 , 0.6],  [0.25,0.6],  [0.6, 0.6],

        ];

        for (let i = 0; i < this.arrSp.length; i++)
        {
            let sprite = this.arrSp[i];
            sprite.width = xOffset ;
            sprite.height = yOffset;


            let p = pos[i];

            sprite.x = p[0] * width;
            sprite.y = p[1] * height;

        }

        return;

        let size = {width, height};


        if (this.responsive.scale)
        {
            let ratio = this.getScaleRelativeRatio(width, height);

            super.scale.x = this.responsive.scale.x * ratio.x;
            super.scale.y = this.responsive.scale.y * ratio.y;
        }

        if (this.responsive.screen)
        {
            let strBasedOn = this.responsive.screen.scale;

            if (strBasedOn === "width")
            {
                this.width = width;
                this.scale.y = this.scale.x;
            }
            else if (strBasedOn === "height")
            {
                this.height = height;
                this.scale.x = this.scale.y;
            }
            else if (strBasedOn === "fillscreen")
            {
                let originalSize = this._texture.orig;

                let originalRatio = originalSize.width / originalSize.height;
                let currentRatio = width / height;

                //if currentRatio is larger than originalRatio, means that we must fill using width
                if (currentRatio > originalRatio)
                {
                    this.width = width;
                    this.scale.y = this.scale.x;
                }
                //if currentRatio is smaller than originalRatio, means that we must fill using height
                else
                {
                    this.height = height;
                    this.scale.x = this.scale.y;
                }


            }
        }

        for (let strKey in this.responsive.params)
        {
            let param = this.responsive.params[strKey];
            let gravity = param.gravity;
            let using = size[param.using];

            this[strKey] = gravity * using;


        }


    }

    getScaleRelativeRatio (width, height)
    {
        width = width || window.innerWidth;
        height = height || window.innerHeight;

        let size = {width, height};

        let iRatioX = 1;
        let iRatioY = 1;

        if (this.responsive.scale.relative)
        {
            if (this.responsive.scale.relative.x)
            {
                let relativeTo = this.responsive.scale.relative.x.to;
                let iBaseValue = this.responsive.scale.relative.x.baseValue;

                iRatioX = size[relativeTo] / iBaseValue;
            }

            if (this.responsive.scale.relative.y)
            {
                let relativeTo = this.responsive.scale.relative.y.to;
                let iBaseValue = this.responsive.scale.relative.y.baseValue;

                iRatioY = size[relativeTo] / iBaseValue;
            }
        }

        return {x: iRatioX, y:iRatioY};

    }

    fadeIn (duration = 1, delay = 0)
    {
        gsap.to(this, {alpha: 1, delay,duration });
    }


}
